module.exports = __webpack_public_path__ + "static/media/foundation_finance.409816bf.png";